<template>
  <div>
    <h3 class="email--subject">{{ email.email_subject }}</h3>

    <!--From-->
    <p class="email--from">
      <strong>{{ email.email_from.name }}</strong> {{ email.email_from.email_address }}
    </p>

    <!--To-->
    <p class="email--to">to:
      <span v-for="(to, index) in email.email_to" :key="index">
        <template v-if="index !== 0">,</template>{{mapNameToUser(to)}} ({{ to.email_address }})
      </span>
    </p>

    <!--cc-->
    <p class="email--to" v-if="email.email_cc.length !== 0">
      cc:
      <span v-for="(cc, index) in email.email_cc" :key="index">
        <template v-if="index !== 0">,</template>{{mapNameToUser(cc)}} ({{ cc.email_address }})
      </span>
    </p>

    <!--bcc-->
    <p class="email--to" v-if="email.email_bcc.length !== 0">
      bcc:
      <span v-for="(bcc, index) in email.email_bcc" :key="index">
        <template v-if="index !== 0">,</template>{{ mapNameToUser(bcc) }} ({{ bcc.email_address }})
      </span>
    </p>

    <!--attachments-->
    <div v-if="email.attachments.length" class="email--attachments">
      attachments:
      <button-link
        class="email--attachments--file"
        v-for="(attachment, index) in email.attachments"
        :key="index"
        @click="downloadAttachment(attachment)"
      >
        {{ attachment.filename }}
      </button-link>
    </div>

    <!--lead-->
    <p class="email--lead" v-if="email.record_id && !hideLeadLink" @click="openRecordModal(email.record_id)">
      Associated Lead: {{ email.record_address }}
    </p>

    <!--body-->
    <div class="email--body" v-html="email.email_body"></div>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import router from "../../../router";

export default {
  name: "EmailPreview",
  props: {
    email: {
      type: Object,
      required: true
    },
    hideLeadLink: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    users() {
      const integrationType = this.$store.getters.market.email_integration_type

      if (integrationType === ENUMS.EmailIntegrationTypeEnum.Gmail.value) {
        return this.$store.getters.gmailActiveUsers
      }

      if (integrationType === ENUMS.EmailIntegrationTypeEnum.MailGun.value) {
        return this.$store.getters.mailgunActiveUsers
      }

      return []
    },
  },
  methods: {
    mapNameToUser(list) {
      if (list.length === 0) return;

      if (list.name !== '') {
        return list.name;
      }

      const user = this.users.find(u => u.outgoing_email_address === list.email_address)
      return (user) ? user.full_name : '';
    },
    openRecordModal(id) {
      this.$utils.closeCommEmailModal();
      this.$nextTick(() => {
        this.$utils.closeContactModal();
        router.replace({query: {lead: id}});
      })
    },
    downloadAttachment(attachment) {
      const data = {
        'id': attachment.id,
        'comm_log_id': this.email.id
      }

      this.$api.download.emailAttachment(data)
        .then(res => {
          this.$utils.processDownload(res, attachment.filename)
        });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.email {

  &--subject {
    font-size: 1.625rem;
    font-weight: 600;
  }

  &--from {
    margin-top: 12px;
    margin-bottom: 6px;

    strong {
      font-weight: 600;
    }
  }

  &--to {
    margin-top: 4px;
    font-size: 0.875rem;
    color: $text-light;
  }

  &--attachments {
    display: flex;
    margin-top: 4px;
    font-size: 0.875rem;
    color: $text-light;

    &--file {
      margin-left: 6px;
    }
  }

  &--lead {
    margin-top: 20px;
    font-size: 0.875rem;
    color: $link;
    cursor: pointer;

    &:hover {
      color: $orange;
    }
  }

  &--body {
    min-height: 300px;
    margin: 1rem (-10px) 0;
    padding: 1rem 10px;
    border-top: 1px solid $borderDark;
    white-space: pre-line;
  }
}
</style>
